import { helpers } 		from './theme/helpers.js';
import { hamburger } 	from './theme/components/hamburger.js';
import { modal } 		from './theme/components/modal.js';
import { sliders } 		from './theme/components/sliders.js';
import { edit } 		from './theme/components/edit.js';

window.theme = {
	globals: {
		isTouch: typeof window !== 'undefined' && 'ontouchstart' in window,
		isTabActive: true,
	},
	init: function () {
		var self = this;

		// Global
		self.smoothScroll.init();
		self.onloadClass();
		self.touch();

		self.faq();
		self.filter_gallery();
		self.inlineYoutube();

		self.offsetHeader();
		self.listStyleImage();
		
		self.openSearch();
		self.closeSearch();

		self.autoSizeTextarea();

		self.paraxify();

		self.tippy();

		self.tabs();

		self.lazyVideo();
		self.formsReplace();

		modal.init();
		hamburger.init();
		sliders.init();
		edit.init();

		jQuery(document).on("click", ".scroll-top-button" , function(e) { e.preventDefault(); jQuery('html, body').animate({scrollTop:0}, 500, 'swing');; });
	},

	onloadClass: function () {
		document.querySelector('body').classList.add('loaded');
	},

	listStyleImage: function() {
		jQuery( 'ul[class*="ul-"]' ).each( function(){
			// var icon = jQuery( this ).data( 'list-image' );
			var line_height = jQuery( this ).find( 'li' ).first().css( 'line-height' );

			
			// jQuery( this ).css( '--list-image', icon );
			jQuery( this ).css( '--line-height', line_height );
		});
	},

	formsReplace: function() {
		if( jQuery( '.wpdev-form-control-wrap' ).length ) {
			jQuery( '.wpdev-form-control-wrap input[type="text"]' ).each( function() {
				var input 			= jQuery( this );
				var inputName 		= input.attr( 'name' );
				
				if( inputName.includes( 'name' ) ) {
					input.attr( 'autocomplete', 'name' );
					return;
				}

				if( inputName.includes( 'email' ) ) {
					input.attr( 'autocomplete', 'email' );
					return;
				}

				if( inputName.includes( 'phone' ) ) {
					input.attr( 'autocomplete', 'tel' );
					return;
				}
			});
		}
		
	},

	offsetHeader: function () {
		if( jQuery( 'body' ).hasClass( 'hide-header-footer' ) ) {
			return false;
		}

		var headerHeight 	= parseInt( jQuery( '.header' ).outerHeight() );
		var offset 			= headerHeight;

		if( jQuery( '.buy' ).length ) {
			var previewBuyBar 	= parseInt( jQuery( '.buy' ).outerHeight() );
			offset 				= offset + previewBuyBar;
		}

		jQuery( 'body' ).css('--header-height', offset + 'px' );

		if( jQuery( '.header' ).hasClass( 'header--overlay') ) {
			jQuery( '.content > section' ).removeAttr('style');
			
			jQuery( '.content > section' ).first().css('--header-overlay-offset', offset + 'px' );
			//jQuery( '.content > section' ).first().css('min-height', firstBlockMinHeight + 'px' );
		} else {
			jQuery( '.content' ).css('padding-top', offset + 'px' );
		}
	},

	faq: function () {
		jQuery( document ).on('click', '.js-faq > h2', function (e) {
			e.preventDefault();

			jQuery( this ).next('div').slideToggle( 'fast' );
			jQuery( this ).parent( '.js-faq' ).toggleClass( 'active' );
        });
	},

	paraxify: function () {
		var myParaxify = paraxify('.paraxify', {
			speed: 1,
			boost: 1,
		});

		if( jQuery( '.paraxify' ).length ) {
			setTimeout(function () {
				jQuery(window).scroll();
			}, 100);
		}
	},

	tippy: function () {
		tippy('[data-tippy-content]', {
			allowHTML: true,
			interactive: true,
		});
	
	},

	tabs: function () {
		jQuery('.tabs__nav a, .tabs-wsw__nav div').on('click', function (e) {
			e.preventDefault();
			
			jQuery( this ).closest( '.js-tabs' ).find( '.active' ).removeClass( 'active' );

			var newActiveTab = jQuery( this ).data( 'href' );
			jQuery( this ).parent().addClass( 'active' );
			jQuery( this ).closest( '.js-tabs' ).find( '[data-name="'+ newActiveTab +'"]' ).addClass( 'active' );
        });
	},


	filter_gallery: function () {
		jQuery( document ).on('click', '.js-filter-gallery-nav a', function (e) {
			e.preventDefault();

			var group_selector = $(this).attr( 'href');
			group_selector = group_selector.substr( 1, group_selector.length);

			jQuery( this ).closest('ul').find('.active').removeClass('active');
			jQuery( this ).parent().addClass('active');

			if( group_selector == 'gallery-all') {
				jQuery( this ).parents('.filter-gallery').find('.js-filter-gallery-item').show();
			}
			else {
				jQuery( this ).parents('.filter-gallery').find('.js-filter-gallery-item').hide();
				jQuery( this ).closest('.filter-gallery').find('.' + group_selector).show();
			}

		});
	},

	autoSizeTextarea: function () {
		$('body').delegate( 'textarea', 'change paste keyup keydown', function (){
			$(this).css( 'height', 0);
			var scrollHeight = this.scrollHeight;
			var textareaHeight = scrollHeight;			
			$(this).css( 'height', textareaHeight + 'px' );
		});
	},

	inlineYoutube: function () {
		jQuery( document ).on( "click", ".youtube__player" , function() {
			var video_id = jQuery( this ).find( '.youtube-inline-player' ).data("youtube");
			jQuery( this ).addClass('played');
			jQuery( this ).html('<iframe src="https://www.youtube.com/embed/' + video_id + '?autoplay=1&mute=0&rel=0&" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen class="parent-background"></iframe>');
		});
	},

	lazyVideo: function () {
		jQuery('source[data-src]').each(function(){
			var sourceFile = $( this ).attr('data-src');
			$(this).attr('src', sourceFile);

			var videoElement = jQuery(this).parent().get(0);
			if (!videoElement.playing) {
				videoElement.load();
				videoElement.play();
			}

			$(this).removeAttr('data-src', sourceFile);
		});
    },

	touch: function () {
		var self = this;

		var touchClass = self.globals.isTouch === true ? 'touch-device' : 'pointer-device';
		document.querySelector('body').classList.add( touchClass );
	},
	smoothScroll: {
		selector: 'a[href*="#"]:not([href="#"])',
		init: function () {
			var self = this;
			var scroll = new SmoothScroll(self.selector, {
				ignore: '[data-scroll-ignore]',
				topOnEmptyHash: false,
				speed: 1000,
				offset: function (anchor, toggle) {
					var headerOffset = jQuery( '.header.header--p-fixed .header__row').outerHeight();

					if( jQuery( anchor ).offset().top < jQuery( window ).scrollTop() + headerOffset ) {
						headerOffset = jQuery( '.header.header--p-fixed' ).css( '--header-height' )
						headerOffset = headerOffset.replace( 'px', '');
					}

					if( !headerOffset ) {
						headerOffset = 0;
					}
	
					return headerOffset;
				},
				updateURL: false,
				easing: 'easeInOutCubic',
			});
		},
	},
	openSearch: function () {
		jQuery('.js-openSearch').on('click', function (event) {
			event.preventDefault();
			
			jQuery(".js-search").fadeIn();
			jQuery(".js-search .container").addClass("active");
			jQuery(".js-search input[type=search]").focus();
        });
	},
	closeSearch: function () {
		jQuery('.js-search').on('click', function (event) {

			if (!jQuery(event.target).closest(".js-search .container").length) {
				jQuery(".js-search").fadeOut();
				jQuery(".js-search .container").removeClass("active");
			}
        });

		jQuery(document).keyup(function(e) {
			if(jQuery(".js-search").length) {
				if (e.key === "Escape") {
					jQuery(".js-search").fadeOut();
					jQuery(".js-search .container").removeClass("active");
				}
			}
	   });
	},

	hideShowHeader: function () {
		var self = this;
		var currentScroll = self.windowPosition()['y'];
		var fixedHeader = currentScroll > 0;
		var scrollUp = "scroll-up";
		var scrollDown = "scroll-down";
		var body = document.querySelector('body');

		if ( fixedHeader && jQuery( '.header' ).hasClass('header--p-fixed') ) {
			body.classList.add('fixed-header');

			if( currentScroll >= 100 ) {
				if (currentScroll > self.globals.lastScroll && !body.classList.contains(scrollDown)) {
					// down
					body.classList.remove(scrollUp);
					body.classList.add(scrollDown);

					var smallMenuHeight = 0;
					if( jQuery( '.header__row--small' ).length ) {
						var smallMenuHeight = jQuery( '.header__row--small' ).outerHeight();
					}

					var messageHeight = 0;
					if( jQuery( '.header-message' ).next( 'div' ).length ) {
						var messageHeight = jQuery( '.header-message' ).outerHeight();
					}
					else {
						jQuery( '.header-message' ).addClass('hide');
					}

					var hideOffset = smallMenuHeight + messageHeight;

					jQuery( '.header' ).css( 'transform', 'translateY(-'+ hideOffset +'px) ');
					jQuery( '.header' ).css( '--hidden-offset', hideOffset + 'px');

				} else if (currentScroll < self.globals.lastScroll && body.classList.contains(scrollDown)) {
					// up
					body.classList.remove(scrollDown);
					body.classList.add(scrollUp);
					jQuery( '.header' ).css( 'transform', 'translateY(0) ');
					jQuery( '.header' ).css( '--hidden-offset', 0);
					jQuery( '.header-message' ).removeClass( 'hide' );
				}
			} else {
				body.classList.remove(scrollUp);
				body.classList.remove(scrollDown);
				jQuery( '.header' ).css( 'transform', 'translateY(0) ');
				jQuery( '.header' ).css( '--hidden-offset', 0);
				jQuery( '.header-message' ).removeClass( 'hide' );
			}

			self.globals.lastScroll = currentScroll;
		} else {
			document.querySelector('body').classList.remove('fixed-header');
		}
	},

	windowPosition: function () {
		return {
			x: window.pageXOffset || document.documentElement.scrollLeft,
			y: window.pageYOffset || document.documentElement.scrollTop,
		};
	},
	windowSizes: function () {
		return {
			width: Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0),
			height: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0),
		};
	},
	onresize() {
		var self = this;
		self.offsetHeader();

		self.hideShowHeader();
	},
	onscroll(position, previusPosition) {
		var self = this;
		var currentScroll = self.windowPosition()['y'];

		if(  currentScroll >= 100 ) {
			jQuery( '.scroll-top-button' ).addClass( 'active' );
		} else {
			jQuery( '.scroll-top-button' ).removeClass( 'active' );
		}


		self.hideShowHeader();	
	},
};

jQuery(document).ready(function ($) {
	theme.init();
});

window.addEventListener('scroll', function (e) {
	theme.onscroll();
});

window.addEventListener('resize', function (e) {
	theme.onresize();
});

window.onfocus = function () { 
	theme.globals.isTabActive = true; 
}; 

window.onblur = function () { 
	theme.globals.isTabActive = false; 
}; 

jQuery.fn.isOnScreen = function(){
    var win = jQuery(window);

    var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
    };
    viewport.right = viewport.left + win.width();
    viewport.bottom = viewport.top + win.height();

    var bounds = this.offset();
    bounds.right = bounds.left + this.outerWidth();
    bounds.bottom = bounds.top + this.outerHeight();

    return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
};